import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind class-name combiner — handles conflicting classes correctly. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
